import React from 'react';

import { faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonGroup, Dropdown, DropdownButton } from 'react-bootstrap';

import alertMessages from '../../../helpers/alertMessages';
import messages from '../../../constants/messages';
import api from '../../../helpers/api';
import { getApiPrefix } from '../../../helpers/authHelper';
import es from '../../../lang/es';

const HistoryAttachment = ({ proceeding, history }) => {
    //Manejo la descarga de adjuntos
    const handleDownload = async file => {
        //Ejecuto
        try{
            //Cargo espera
            alertMessages.waiting(messages.LOADING.DOWNLOADING);
            //Armo los datos de la consulta
            const data = {
                jurisdiction: proceeding.jurisdiction_id,
                proceeding: proceeding.procid,
                history: history.history.histid,
                file: btoa(file.nombre)
            }
            //COnsulta
            const response = await api.post(`${getApiPrefix()}/proceedings/history/file`, data);
            //Obtengo los datos
            const res = response.data;
            //Abro en nueva ventana la URL
            window.open(res.data);
            //Oculto la espera
            alertMessages.close();
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: messages.ERROR.SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Cierro la espesra
            alertMessages.close();
            //Mensaje de error
            alertMessages.error(data.message);
        }
    }
    //Render
    return (
        <DropdownButton
            as={ButtonGroup}
            className="float-right ml-2"
            drop="up"
            title={
                <>
                <FontAwesomeIcon icon={ faPaperclip } /> <strong>{ es.HISTORY_ATTACH.toUpperCase() }</strong>
                </>
            }
            variant="warning"
        >
            {
                history.history.archivos.map((archivo, index) => (
                    <Dropdown.Item
                        key={`had-${index}`}
                        onClick={() => handleDownload(archivo)}
                    >
                        <strong>{`ADJUNTO #${index + 1} (${archivo.extension.toUpperCase()}) - `}</strong> <i>{es.DOWNLOAD.toUpperCase()}</i>
                    </Dropdown.Item>
                ))
            }
        </DropdownButton>
    );
};

export default HistoryAttachment;